import * as Sentry from '@sentry/browser';
import * as actions from 'actions/conversation';
import { parseError, toSentryError } from 'logic/helpers';

export const handleSignError = (err, { dispatch, resetUploader }) => {
  if (err?.status === 401) {
    dispatch(actions.conversationUploadFileFailure({ error: {} }));
    resetUploader();
    return;
  }

  Sentry.captureException(toSentryError(err, 'sign-request'), {
    tags: { stage: 'sign-request' },
  });
  const parsed = parseError(err || {});
  dispatch(
    actions.conversationUploadFileFailure({
      error: { ...parsed.error, canTryAgain: true, timestamp: Date.now() },
    }),
  );
  resetUploader();
};
